import type { EditorToRendererMessageType } from "@lureo/editor-contracts";

// The one list of the messages, newer than the bridge's first version, that this renderer handles: the host's
// rendererLoaded.accepts and every bridge's `accepts`, in the order Unity's build lists them, newer ones after. A port
// adds a message here only once it handles it, so the editor never sends one the renderer would drop. readAfter and
// readHomeUntil are handled by the runtime's RegionRouting.
export const RENDERER_ACCEPTS: readonly EditorToRendererMessageType[] = Object.freeze([
  "setViewportTheme",
  "clearSelection",
  "readAfter",
  "readHomeUntil",
]);
